/**
 * Diagnox cart drawer — remove, recommend/add, variant select, upsell refresh.
 */
(function () {
  'use strict';

  var DRAWER = '#CartDrawer';
  var FORM = '#CartDrawerForm';

  function getCartAddUrl() {
    if (window.theme && theme.routes && theme.routes.cartAdd) return theme.routes.cartAdd;
    return '/cart/add.js';
  }

  function formatMoney(cents) {
    if (window.theme && theme.Currency && theme.settings) {
      return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    }
    return '$' + (Number(cents) / 100).toFixed(2);
  }

  function refreshUpsellFromHtml(html) {
    var form = document.querySelector(FORM);
    if (!form) return;

    var slot = form.querySelector('[data-diagnox-upsell-slot]');
    if (!slot) return;

    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var markup = doc.querySelector('[data-diagnox-upsell-markup]');
    slot.innerHTML = markup ? markup.innerHTML : '';
    syncUpsellVisibility();
  }

  function refreshShippingFromHtml(html) {
    var form = document.querySelector(FORM);
    if (!form) return;

    var slot = form.querySelector('[data-diagnox-shipping-slot]');
    if (!slot) return;

    var parser = new DOMParser();
    var doc = parser.parseFromString(html, 'text/html');
    var markup = doc.querySelector('[data-diagnox-shipping-markup]');
    slot.innerHTML = markup ? markup.innerHTML : '';
  }

  function syncUpsellVisibility() {
    var slot = document.querySelector('[data-diagnox-upsell-slot]');
    if (!slot) return;
    var upsell = slot.querySelector('[data-diagnox-cart-upsell]');
    if (!upsell) {
      slot.hidden = true;
      return;
    }
    var slides = upsell.querySelectorAll('[data-diagnox-upsell-slide]');
    slot.hidden = slides.length === 0;
  }

  function patchCartMarkup() {
    if (!window.theme || !theme.CartForm || !theme.CartForm.prototype) return;
    if (theme.CartForm.prototype._diagnoxPatched) return;

    var original = theme.CartForm.prototype.cartMarkup;
    theme.CartForm.prototype.cartMarkup = function (html) {
      original.call(this, html);
      if (this.location === 'cart-drawer') {
        refreshUpsellFromHtml(html);
        refreshShippingFromHtml(html);
      }
    };
    theme.CartForm.prototype._diagnoxPatched = true;
  }

  function removeLineItem(key, trigger) {
    if (!key || !window.theme || !theme.cart) return;

    if (trigger) trigger.classList.add('is-loading');

    theme.cart
      .changeItem(key, 0)
      .then(function (cart) {
        document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
        document.dispatchEvent(
          new CustomEvent('cart:updated', {
            detail: { cart: cart },
          })
        );

        if (cart.item_count === 0) {
          document.body.classList.remove('cart-has-items');
          var drawer = document.querySelector(DRAWER);
          if (drawer) drawer.classList.add('is-empty');
        }
      })
      .catch(function () {})
      .finally(function () {
        if (trigger) trigger.classList.remove('is-loading');
      });
  }

  function addUpsell(variantId, button) {
    if (!variantId) return;

    button.setAttribute('disabled', '');
    button.setAttribute('aria-busy', 'true');

    fetch(getCartAddUrl(), {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
      }),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Could not add item');
          return data;
        });
      })
      .then(function (data) {
        document.body.classList.add('cart-has-items');
        document.dispatchEvent(
          new CustomEvent('ajaxProduct:added', {
            detail: { product: data, addToCartBtn: button },
          })
        );
      })
      .catch(function () {
        button.removeAttribute('disabled');
        button.removeAttribute('aria-busy');
      });
  }

  function syncStarterCardVariant(card) {
    if (!card) return;
    var control = card.querySelector('[data-diagnox-starter-variant]');
    var priceEl = card.querySelector('[data-diagnox-starter-price]');
    var addBtn = card.querySelector('[data-diagnox-upsell-add]');
    if (!control || !addBtn) return;

    var variantId = control.value;
    var price = control.getAttribute('data-price');

    if (control.tagName === 'SELECT') {
      var option = control.options[control.selectedIndex];
      if (option) {
        variantId = option.value;
        price = option.getAttribute('data-price');
      }
    }

    addBtn.setAttribute('data-variant-id', variantId);
    if (priceEl && price != null) {
      priceEl.textContent = formatMoney(price);
    }
  }

  function onChange(evt) {
    var select = evt.target.closest('[data-diagnox-starter-variant]');
    if (!select || !select.closest(DRAWER)) return;
    syncStarterCardVariant(select.closest('[data-diagnox-starter-card]'));
  }

  function onClick(evt) {
    var removeBtn = evt.target.closest('[data-diagnox-cart-remove]');
    if (removeBtn && removeBtn.closest(DRAWER)) {
      evt.preventDefault();
      removeLineItem(removeBtn.getAttribute('data-id'), removeBtn);
      return;
    }

    var addBtn = evt.target.closest('[data-diagnox-upsell-add]');
    if (addBtn && addBtn.closest(DRAWER)) {
      evt.preventDefault();
      var card = addBtn.closest('[data-diagnox-starter-card]');
      if (card) syncStarterCardVariant(card);
      addUpsell(addBtn.getAttribute('data-variant-id'), addBtn);
    }
  }

  function init() {
    patchCartMarkup();
    syncUpsellVisibility();
    document.addEventListener('click', onClick);
    document.addEventListener('change', onChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();